var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2167ae",
    d: "M3.5 17.54a.5.5 0 1 1 0-1h15.7l-4.03-3.67a.5.5 0 1 1 .68-.74l4.99 4.54a.5.5 0 0 1 0 .74l-4.91 4.46a.5.5 0 1 1-.68-.74l3.96-3.6zm17-11.08a.5.5 0 0 1 0 1H4.8l4.03 3.67a.5.5 0 1 1-.68.74L3.16 7.33a.5.5 0 0 1 0-.74l4.91-4.46a.5.5 0 1 1 .68.74l-3.96 3.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftArrowRight);
export default __webpack_public_path__ + "static/media/ArrowLeftArrowRight.fe1063820bd86156db458687368c1e16.svg";
export { ForwardRef as ReactComponent };